export enum MyResultsWidgets {
	MyCourses = 'my_courses'
}
